import React from 'react';
import { graphql, Query } from 'react-apollo';
import compose from 'lodash/flowRight';
import GET_CAMPAIGN_REPORT from '../../../GraphQl/Queries/GET_CAMPAIGN_REPORT';
import CURRENT_USER from '../../../GraphQl/Queries/CURRENT_USER';
import Controller from './CampaignDetailsChartsController';
import CampaignDetailsSkeleton from '../../../../platform/ux/Campaigns/campaigndetails/components/CampaignDetailsSkeleton';

const CampaignChartsDataLoader = ({ children, ...props }) => {
  // Campaigns without an attribution report (e.g. DRAFTs) have nothing to
  // fetch — querying with the literal 'null' id returns an empty signed-URL
  // payload that used to leave the charts controller spinning forever.
  // Render the controller directly in its terminal no-report state instead.
  if (!props.attributionReportId) {
    return (
      <Controller url={null} expiresAt={null} refetch={() => {}} {...props}>
        {children}
      </Controller>
    );
  }

  try {
    return (
      <Query
        query={GET_CAMPAIGN_REPORT}
        variables={{
          reportId: props.attributionReportId,
        }}
        fetchPolicy="no-cache"
      >
        {({ loading, error, data, refetch }) => {
          // Chart-report signed-URL loader — runs after the main campaign
          // query completes, while the pre-computed chart data fetches.
          // Page shell still hasn't rendered at this stage, so the
          // full-page skeleton gives the user the same layout-shape
          // anticipation as the mount loader above.
          if (loading) {
            return <CampaignDetailsSkeleton />;
          }
          if (error) return `Error (Query: GET_CAMPAIGN_REPORT)! ${error.message}`;

          const { url, expiresAt } = data.getCampaignReportSignedURL;

          return (
            <Controller refetch={refetch} url={url} expiresAt={expiresAt} {...props}>
              {children}
            </Controller>
          );
        }}
      </Query>
    );
  } catch (err) {
    console.log('err', err);
  }
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(CampaignChartsDataLoader);
